module.exports = __webpack_public_path__ + "static/media/rco-evidence-icon.c2848a90.svg";